import { AxiosInstance } from 'axios';
import { QueryStringBuilder } from '@/shared/api-client/helpers';
import { INewNomination } from '../models/new-nomination';
import { INominationAnswerRequest } from '../models/nomination-answer-request';
import { INominationGroup } from '../models/nomination-group';
import { INominationListEntry } from '../models/nomination-list-entry';
import { IPagedList } from '../models/paged-list';
import { IPagination } from '../models/pagination';

export type NominationExportFileFormat = 'Pdf' | 'Xlsx';

export class NominationClient {

    constructor(private axiosClient: AxiosInstance, private baseUrl: string) {

    }

    public get apiUrl() {
        return `/nomination`;
    }

    public async create(electionId: string, nomination: INewNomination) {

        try {
            await this.axiosClient.post(
                `${this.apiUrl}/${electionId}/candidate`,
                nomination,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async list(electionId: string, nominationGroupIdentifier: string, pagination?: IPagination): Promise<IPagedList<INominationListEntry>> {

        try {

            const url = new QueryStringBuilder()
                .withPaginationIfNotEmpty(pagination)
                .build(`${this.apiUrl}/${electionId}/nominations/${nominationGroupIdentifier}`);

            const response = await this.axiosClient.get(
                url
            );

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async listMyNominees(pagination?: IPagination): Promise<IPagedList<INominationListEntry>> {

        try {

            const url = new QueryStringBuilder()
                .withPaginationIfNotEmpty(pagination)
                .build(`${this.apiUrl}/nominees`);

            const response = await this.axiosClient.get(url);

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public getExportUrl(electionId: string, format: NominationExportFileFormat): string {

        return `${this.baseUrl}${this.apiUrl}/${electionId}/nominations/export?fileFormat=${format}`;
    }

    public async listNominated(electionId: string, pagination?: IPagination, showManaged: boolean = false): Promise<IPagedList<INominationGroup>> {

        try {

            const url = new QueryStringBuilder()
                .withPaginationIfNotEmpty(pagination)
                .withQueryIfNotEmpty('showManaged', showManaged)
                .build(`${this.apiUrl}/${electionId}/nominated`);

            const response = await this.axiosClient.get(
                url,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async answer(electionId: string, answerRequest: INominationAnswerRequest) {

        try {

            await this.axiosClient.post(
                `${this.apiUrl}/${electionId}/answer`,
                answerRequest,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async mapNominationToUser(electionId: string, nominationId: string, userId: string) {

        try {

            await this.axiosClient.post(
                `${this.apiUrl}/${electionId}/mapNominationToUser`,
                {
                    nominationId,
                    userId
                },
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

        } catch (error: any) {

            throw error.response.data;
        }
    }
}
